import React from 'react';
import ReactSVG from 'react-svg';

import loadingIcon from 'appSrc/v5/assets/loading/loading-icon.svg';

const LoadingIcon = ( props ) => {
    const className = `loading-icon-wrapper ${ props.className }`.trim();

    return (
        <ReactSVG src={ loadingIcon }
        wrapper='div'
        { ...props }
        className={ className } />
    );
};
LoadingIcon.defaultProps = {
    className: '',
};

export default LoadingIcon;
